import { useParams, useSearchParams } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { goBack, lightImpactVibrate, onReady, trackEvent } from '../utils/appBridge'
import { KnowWhyBottomSheetContent } from '../components/know-why/KnowWhyBottomSheetContent'
import { useQuery } from '@tanstack/react-query'
import { fetchKnowWhyData } from '../repository/MutualFundDetail'
import Button from '../components/ui-components/Button'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { EventNames } from '../types/misc.types'
import { getBottomPadding } from '../utils/sessionStorage'

export default function KnowWhyPage() {
  const [isin, setISIN] = useState('')
  const { isin: paramsISIN } = useParams<{ isin: string }>()

  const heading = 'Know Why'
  const ScreenName = 'KnowWhyPage'

  useEffect(() => {
    setISIN('')
    setTimeout(() => {
      setISIN(paramsISIN ?? '')
    }, 0)
  }, [paramsISIN])

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])

  const {
    data: knowWhyDataResponse,
    refetch,
    isError
  } = useQuery({
    queryKey: ['knowWhyData', isin],
    queryFn: () => fetchKnowWhyData(isin ?? ''),
    enabled: !!isin,
    retry: 2
  })

  const knowWhyData = useMemo(() => knowWhyDataResponse?.data ?? null, [knowWhyDataResponse])

  useEffect(() => {
    if (knowWhyData) {
      onReady()
    }
  }, [knowWhyData])

  if (isin && knowWhyData)
    return (
      <div className='pb-1 h-full w-full relative bg-[#F0F4F7] animate-fade-150'>
        <div className='h-full pb-24 overflow-y-auto no-scrollbar bg-[#F0F4F7]'>
          {/* KnowWhy Content */}
          <KnowWhyBottomSheetContent knowWhyData={knowWhyData} ScreenName={ScreenName} />
        </div>

        {/* Sticky Bottom Button */}
        <div className='sticky bottom-0 left-0 right-0'>
          <div
            style={{
              paddingBottom: `${getBottomPadding() + 8}px`,
              background: 'linear-gradient(180deg, rgba(240, 244, 247, 0.00) 0%, #F0F4F7 60.38%)'
            }}
            className='w-full px-5 pt-9'
          >
            <Button
              isFullWidth
              label='Close'
              onClick={() => {
                lightImpactVibrate()
                goBack()
              }}
              buttonClassName='w-full !h-[48px] !bg-white !text-[#232323] !text-[16px] !border-[1px] !border-[#F0F4F7] !border-solid'
            />
          </div>
        </div>
      </div>
    )

  return (
    <div className='flex flex-col gap-3 pl-[19px] pr-5 w-full h-screen justify-center items-center'>
      <div>
        {isError ? (
          <div className='text-[#6A6E6E] text-[13px] font-[400] leading-[150%] max-w-[200px] text-center'>
            Error Loading Data.{' '}
            <span onClick={() => refetch()} className='underline cursor-pointer'>
              Retry
            </span>
          </div>
        ) : (
          <LoadingSpinner />
        )}
      </div>
    </div>
  )
}
